<template>
  <div>
    <template v-if="isList">
      <ul class="video-view__list">
        <li v-for="(video, key) in videos" :key="key" :index="key">
          <a :href="video.url" target="_blank">
            {{ video.title }}
          </a>
        </li>
      </ul>
      <ul class="video-view__list-mobile">
        <li v-for="(video, key) in videos" :key="key" :index="key">
          <a :href="video.url" target="_blank">
            {{ video.title }}
          </a>
        </li>
      </ul>
    </template>
    <template v-else>
      <div class="video-view__videos">
        <hooper :ref="getName(false)" :itemsToShow="4" :wheelControl="false" :mouseDrag="false" :touchDrag="false" :trimWhiteSpace="true">
          <slide v-for="(video, key) in videos" :key="key" :index="key">
            <a :href="video.url" target="_blank">
              <p class="video-view__img">
                <img v-if="video.preview_url" :src="video.preview_url" :alt="video.title">
                <img v-else src="/img/no-video.png" alt="">
              </p>
              <p class="video-view__title">
                {{ video.title }}
              </p>
            </a>
          </slide>
        </hooper>
        <div v-if="videos.length > 4" @click.prevent="slidePrev" class="video-view__prev">
          <img src="/img/arrow-left-icon.svg" alt="">
        </div>
        <div v-if="videos.length > 4" @click.prevent="slideNext" class="video-view__next">
          <img src="/img/arrow-left-icon.svg" alt="">
        </div>
      </div>

      <div class="video-view__videos-mobile">
        <hooper :ref="getName(true)" :itemsToShow="2" :wheelControl="false" :trimWhiteSpace="true" :itemsToSlide="2">
          <slide v-for="(video, key) in videos" :key="key" :index="key">
            <a :href="video.url" target="_blank">
              <p class="video-view__img">
                <img v-if="video.preview_url" :src="video.preview_url" :alt="video.title">
                <img v-else src="/img/no-video.png" alt="">
              </p>
              <p class="video-view__title">
                {{ video.title }}
              </p>
            </a>
          </slide>
        </hooper>
      </div>
    </template>
  </div>
</template>

<script>

import {Hooper, Slide} from "hooper";

export default {
  name: 'video-item',
  components: {
    Hooper,
    Slide
  },
  props: {
    videos: {
      require: true,
      type: Array
    },
    postfix: {
      type: String
    },
    isList: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({

  }),
  created() {

  },
  methods: {
    getName(postfix) {
      if (postfix) {
        return 'carousel' + this.postfix + 'm'
      }
      return 'carousel' + this.postfix
    },
    slidePrev() {
      this.$refs[this.getName()].slidePrev();
    },
    slideNext() {
      this.$refs[this.getName()].slideNext();
    },
    toggle() {
      this.showAll = !this.showAll
    }
  }
}
</script>